import { render, staticRenderFns } from "./purchase-receive-dialog.vue?vue&type=template&id=ffc984e6&scoped=true&"
import script from "./purchase-receive-dialog.vue?vue&type=script&lang=js&"
export * from "./purchase-receive-dialog.vue?vue&type=script&lang=js&"
import style0 from "./purchase-receive-dialog.vue?vue&type=style&index=0&id=ffc984e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc984e6",
  null
  
)

export default component.exports